import React, {useState, useEffect} from 'react';
import {useSelector, shallowEqual} from 'react-redux';
import {useList} from 'react-use';
import lodash from 'lodash';

import Checkbox from '../../../../components/checkbox';

const CENTRAL = 'central';
const PACIFIC = 'pacific';

const OPP_CENTRAL = 'oppCentral';
const OPP_PACIFIC = 'oppPacific';

const addChecked = (values, selected) => {
    return values.map(item => {
        const checked = !!selected.find(o => o === item.id);
        return {
            ...item,
            checked
        }

    })
};

const checkAll = (selected, leagues) => {
    return selected.length === leagues.length
};

const getCheckedValue = (values) => {
    return lodash.map(lodash.filter(values, ['checked', true]), 'id')
};
const getNumCheck = (value) => {
    let i = 0;
    lodash.filter(value,item => {
        if(item.checked) i++;
    })
    return i;
}
function TeamCondition(props) {
    const {selected, onChange} = props;

    const leagues = useSelector((state) => state.metadata.leagues, shallowEqual);
    const [selectedTeamAll, setSelectedTeamAll] = useState({
        central: false,
        pacific: false,
    });
    const [selectedOppTeamAll, setSelectedOppTeamAll] = useState({
        oppCentral: false,
        oppPacific: false,
    });

    const [teamCentral, teamCentralHelper] = useList([]);
    const [teamPacific, teamPacificHelper] = useList([]);

    const [oppTeamCentral, teamOppTeamCentralHelper] = useList([]);
    const [oppTeamPacific, teamOppTeamPacificHelper] = useList([]);

    useEffect(() => {
        if(teamCentral.length > 0) {
            if (teamCentral.length === getNumCheck(teamCentral)) {
                setSelectedTeamAll({...selectedTeamAll, central: true})
            }else {
                setSelectedTeamAll({...selectedTeamAll, central: false})
            }
        }
    },[teamCentral])

    useEffect(() => {
        if(teamPacific.length > 0) {
            if (teamPacific.length === getNumCheck(teamPacific)) {
                setSelectedTeamAll({...selectedTeamAll, pacific: true})
            } else {
                setSelectedTeamAll({...selectedTeamAll, pacific: false})
            }
        }
    },[teamPacific])

    useEffect(() => {
        if(oppTeamCentral.length > 0) {
            if (oppTeamCentral.length === getNumCheck(oppTeamCentral)) {
                setSelectedOppTeamAll({...selectedOppTeamAll, oppCentral: true})
            } else {
                setSelectedOppTeamAll({...selectedOppTeamAll, oppCentral: false})
            }
        }
    },[oppTeamCentral])

    useEffect(() => {
        if(oppTeamPacific.length > 0) {
            if (oppTeamPacific.length === getNumCheck(oppTeamPacific)) {
                setSelectedOppTeamAll({...selectedOppTeamAll, oppPacific: true})
            } else {
                setSelectedOppTeamAll({...selectedOppTeamAll, oppPacific: false})
            }
        }
    },[oppTeamPacific])

    useEffect(() => {
        teamCentralHelper.set(addChecked(leagues.central, selected.team.central));
        teamPacificHelper.set(addChecked(leagues.pacific, selected.team.pacific));
        setSelectedTeamAll({
            central: checkAll(selected.team.central, leagues.central),
            pacific: checkAll(selected.team.pacific, leagues.pacific),
        });
        teamOppTeamCentralHelper.set(addChecked(leagues.central, selected.oppTeam.central));
        teamOppTeamPacificHelper.set(addChecked(leagues.pacific, selected.oppTeam.pacific));
        setSelectedOppTeamAll({
            oppCentral: checkAll(selected.oppTeam.central, leagues.central),
            oppPacific: checkAll(selected.oppTeam.pacific, leagues.pacific),
        })

    }, [leagues]);

    useEffect(() => {
        onChange({
            team: {
                central: getCheckedValue(teamCentral),
                pacific: getCheckedValue(teamPacific),
            },
            oppTeam: {
                central: getCheckedValue(oppTeamCentral),
                pacific: getCheckedValue(oppTeamPacific),
            },
        });
    }, [teamCentral, teamPacific, oppTeamCentral, oppTeamPacific]);


    const onSelectAllTeam = (type) => {
        const list = type === CENTRAL ? teamCentral : teamPacific;
        const helper = type === CENTRAL ? teamCentralHelper : teamPacificHelper;
        const checked = !selectedTeamAll[type];
        helper.set(lodash.map(list, (item) => {
            return {
                ...item,
                checked,
            }
        }));
        setSelectedTeamAll({
            ...selectedTeamAll,
            [type]: checked
        });

    };

    const onSelectOppAllTeam = (type) => {
        const list = type === OPP_CENTRAL ? oppTeamCentral : oppTeamPacific;
        const helper = type === OPP_CENTRAL ? teamOppTeamCentralHelper : teamOppTeamPacificHelper;
        const checked = !selectedOppTeamAll[type];
        helper.set(lodash.map(list, (item) => {
            return {
                ...item,
                checked,
            }
        }));
        setSelectedOppTeamAll({
            ...selectedOppTeamAll,
            [type]: checked
        });

    };

    const onSelectTeam = (team, index, type) => {
        if(type === CENTRAL) {
            teamCentralHelper.updateAt(index, {
                ...team,
                checked: !team.checked,
            });
            return;
        }

        if(type === PACIFIC) {
            teamPacificHelper.updateAt(index, {
                ...team,
                checked: !team.checked,
            });
        }

        if(type === OPP_CENTRAL) {
            teamOppTeamCentralHelper.updateAt(index, {
                ...team,
                checked: !team.checked,
            });
        }

        if(type === OPP_PACIFIC) {
            teamOppTeamPacificHelper.updateAt(index, {
                ...team,
                checked: !team.checked,
            });
        }
    };
    return <>
        <div style={{ paddingTop: 0, paddingLeft: 0}}>
            <label className="radio-detailed-search">チーム
                <input type="radio" defaultChecked="checked" name="radio"/>
                <span className="checkmark" />
            </label>
        </div>
        <div>
            <p className="smallTitle">所属チーム</p>
            <div className="container-flexbox">
                <div className="container-items">
                    <div>
                        <div className={'search-main-advanced-checkbox'}>
                            <label>
                                <Checkbox onChange={() => onSelectAllTeam(CENTRAL)} checked={selectedTeamAll.central}/>
                                セ・リーグ
                            </label>
                        </div>
                        <div className={'list-item-checkbox'}>
                            {teamCentral.map((item, index) => {
                                return <div key={item.id + 'central'} className={'search-main-advanced-checkbox group-name-team item-check'}>
                                    <label>
                                        <Checkbox onChange={() => onSelectTeam(item, index, CENTRAL)} checked={item.checked} name='team-related'/>
                                        {item.team_name_s}
                                    </label>
                                </div>
                            })}
                        </div>
                    </div>
                    <div>
                        <div className={'search-main-advanced-checkbox'}>
                            <label>
                                <Checkbox onChange={() => onSelectAllTeam(PACIFIC)} checked={selectedTeamAll.pacific}/>
                                パ・リーグ
                            </label>
                        </div>
                        <div className={'list-item-checkbox'}>
                            {teamPacific.map((item, index) => {
                                return <div key={item.id + 'pacific'} className={'search-main-advanced-checkbox group-name-team item-check'}>
                                    <label>
                                        <Checkbox onChange={() => onSelectTeam(item, index, PACIFIC)} checked={item.checked} value={item.id} name='team-related'/>
                                        {item.team_name_s}
                                    </label>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <p className="smallTitle">対戦チーム</p>
            <div className="container-flexbox">
                <div className="container-items">
                    <div>
                        <div className={'search-main-advanced-checkbox'}>
                            <label>
                                <Checkbox checked={selectedOppTeamAll.oppCentral} onChange={() => onSelectOppAllTeam(OPP_CENTRAL)}/>
                                セ・リーグ
                            </label>
                        </div>
                        <div className={'list-item-checkbox'}>
                            {oppTeamCentral.map((item, index) => <div key={item.id + 'opp_central'} className={'search-main-advanced-checkbox group-name-team item-check'}>
                                <label>
                                    <Checkbox onChange={() => onSelectTeam(item, index, OPP_CENTRAL)} checked={item.checked} value={item.id} name='team-related'/>
                                    {item.team_name_s}
                                </label>
                            </div>)}
                        </div>
                    </div>
                    <div>
                        <div className={'search-main-advanced-checkbox'}>
                            <label>
                                <Checkbox checked={selectedOppTeamAll.oppPacific} onChange={() => onSelectOppAllTeam(OPP_PACIFIC)}/>
                                パ・リーグ
                            </label>
                        </div>
                        <div className={'list-item-checkbox'}>
                            {oppTeamPacific.map((item, index) => <div key={item.id + 'opp_pacific'} className={'search-main-advanced-checkbox group-name-team item-check'}>
                                <label>
                                    <Checkbox onChange={() => onSelectTeam(item, index, OPP_PACIFIC)} checked={item.checked} value={item.id} name='team-related'/>
                                    {item.team_name_s}
                                </label>
                            </div>)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default TeamCondition;
